import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import CreateNewTicketForm from '@components/Forms/CreateNewTicketForm/CreateNewTicketForm';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { HTTP_503_SERVICE_UNAVAILABLE } from '@config/const';
import { Page500 } from '@containers/ErrorPages';
import { ticketApi } from '@reducers/tickets/tickets';

export const CreateTicket = () => {
  const { isError, error, isLoading } = ticketApi.useGetTicketCountriesQuery();
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    if (error.status === HTTP_503_SERVICE_UNAVAILABLE) {
      return (
        <Page500 title="Service unavailable" getMessage={() => error.data} />
      );
    }
    return <Page500 />;
  }

  return (
    <Row>
      <Col md={6}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            Create ticket
          </Card.Header>
          <Card.Body>
            <CreateNewTicketForm />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
